(function() {
  window.__TUOKUS_RAIL_STABILIZER_ACTIVE = true;

  var PRODUCT_SECTION_SELECTOR = '[data-section-type="product"]';
  var COPY_BUTTON_SELECTOR = '[data-tuokus-copy-coupon], [data-copy-coupon], [data-coupon-copy-button]';
  var GENERIC_RAIL_SELECTOR = '.product-gallery__thumbnail-list, .tuokus-promo-module__rail, .product-list--scrollable, .activity-product-list, .activity-collection-grid, .tuokus-collection-discovery__rail';
  var SEARCH_FORM_SELECTOR = 'form.search-bar, form[role="search"], form[action*="/search"]';
  var SEARCH_INPUT_SELECTOR = 'input[name="q"], input[type="search"], .search-bar__input';
  var dragMap = new WeakMap();
  var railScrollMemory = Object.create(null);

  function toArray(list) {
    return Array.prototype.slice.call(list || []);
  }

  function isMobileViewport() {
    return window.innerWidth <= 999;
  }

  function normalizeToken(value) {
    return String(value || '').trim().toLowerCase();
  }

  function cssEscape(value) {
    if (window.CSS && typeof window.CSS.escape === 'function') {
      return window.CSS.escape(String(value || ''));
    }

    return String(value || '').replace(/["\\]/g, '\\$&');
  }

  function normalizeCouponCode(value) {
    var text = String(value || '').trim();
    var match = text.match(/\b[A-Z0-9][A-Z0-9_-]{4,}\b/i);

    return (match ? match[0] : text).toUpperCase();
  }

  function getDirectChild(parent, selector) {
    return toArray(parent && parent.children).find(function(child) {
      return child.matches && child.matches(selector);
    }) || null;
  }

  function setText(node, value) {
    if (node) {
      node.textContent = value;
    }
  }

  function injectRuntimeStyles() {
    var style = document.getElementById('tuokus-live-recovery-runtime-style');

    if (style) {
      document.head.appendChild(style);
      return;
    }

    style = document.createElement('style');
    style.id = 'tuokus-live-recovery-runtime-style';
    style.textContent = [
      '@media screen and (max-width: 999px) {',
      '.template-product [data-section-type="product"] .product-block-list, .template-product [data-section-type="product"] .product-block-list__wrapper, .template-product [data-section-type="product"] .product-block-list__item, .template-product [data-section-type="product"] .product-info, .template-product [data-section-type="product"] .product-info__block-list, .template-product [data-section-type="product"] .product-info__block-item, .template-product [data-section-type="product"] .product-form__variants--static, .template-product [data-section-type="product"] variant-picker, .template-product [data-section-type="product"] .product-form__option, .template-product [data-section-type="product"] .product-form__option-selector, .template-product [data-section-type="product"] .product-form__info-list, .template-product [data-section-type="product"] .product-form__pricing-panel { box-sizing: border-box !important; width: 100% !important; max-width: 100% !important; min-width: 0 !important; }',
      '.template-product [data-section-type="product"] .product-gallery, .template-product [data-section-type="product"] .product-gallery__carousel-wrapper, .template-product [data-section-type="product"] .product-gallery__carousel, .template-product [data-section-type="product"] .product-gallery__size-limiter, .template-product [data-section-type="product"] .flickity-viewport { box-sizing: border-box !important; width: 100% !important; max-width: 100% !important; min-width: 0 !important; }',
      '.template-product [data-section-type="product"] .variant-swatch-list { display: flex !important; flex-wrap: nowrap !important; justify-content: flex-start !important; align-items: center !important; gap: 4px !important; column-gap: 4px !important; grid-auto-columns: unset !important; overflow-x: auto !important; overflow-y: hidden !important; padding: 0 0 2px !important; margin: 0 !important; scroll-snap-type: none !important; scroll-padding-inline: 0 !important; scroll-behavior: auto !important; overscroll-behavior-x: contain !important; touch-action: pan-x pan-y pinch-zoom !important; -webkit-overflow-scrolling: touch !important; }',
      '.template-product [data-section-type="product"] .variant-swatch-list > .variant-swatch { flex: 0 0 76px !important; width: 76px !important; min-width: 76px !important; max-width: 76px !important; height: 76px !important; margin: 0 !important; scroll-snap-align: none !important; }',
      '.template-product [data-section-type="product"] .variant-swatch__item { display: flex !important; align-items: center !important; justify-content: center !important; width: 76px !important; min-width: 76px !important; height: 76px !important; min-height: 76px !important; padding: 4px !important; gap: 0 !important; }',
      '.template-product [data-section-type="product"] .variant-swatch__media, .template-product [data-section-type="product"] .variant-swatch__media.aspect-ratio { width: 68px !important; height: 68px !important; min-width: 68px !important; min-height: 68px !important; padding-bottom: 0 !important; border-radius: 13px !important; overflow: hidden !important; }',
      '.template-product [data-section-type="product"] .variant-swatch__image { width: 68px !important; height: 68px !important; object-fit: cover !important; }',
      '.template-product [data-section-type="product"] .variant-swatch__label { display: none !important; height: 0 !important; min-height: 0 !important; margin: 0 !important; padding: 0 !important; overflow: hidden !important; }',
      '.template-product [data-section-type="product"] .product-form__info-list--secondary .product-form__info-item--quantity { display: flex !important; flex-direction: row !important; justify-content: flex-start !important; align-items: center !important; gap: 10px !important; min-height: 42px !important; padding: 4px 0 !important; }',
      '.template-product [data-section-type="product"] .quantity-selector--product { width: 150px !important; max-width: 150px !important; margin: 0 !important; }',
      '}'
    ].join('');
    document.head.appendChild(style);
  }

  function hasMojibake(text) {
    return /[\uFFFD\u00C2\u00C3\u00E3]|(?:銈|銉|鍟|鏃|閰|闁|閵|杩|搧|瑭|崇|鎵|鐟|鋒|鑹)/.test(String(text || ''));
  }

  function normalizeSupportCopy(root) {
    var scope = root && root.querySelectorAll ? root : document;
    var contentTitles = [
      '\u30b5\u30a4\u30ba\u306b\u3064\u3044\u3066',
      '\u304a\u624b\u5165\u308c\u65b9\u6cd5',
      '\u914d\u9001\u30fb\u8fd4\u54c1\u306b\u3064\u3044\u3066'
    ];
    var refundMarkup = [
      '<h2>\u914d\u9001\u30fb\u8fd4\u54c1\u30dd\u30ea\u30b7\u30fc\u306b\u3064\u3044\u3066</h2>',
      '<p>\u65e5\u672c\u3078\u306e\u304a\u5c4a\u3051\u76ee\u5b89\u306f\u901a\u5e388\u301c11\u65e5\u3067\u3059\u3002\u5730\u57df\u3084\u914d\u9001\u72b6\u6cc1\u306b\u3088\u308a\u524d\u5f8c\u3059\u308b\u5834\u5408\u304c\u3042\u308a\u307e\u3059\u306e\u3067\u3001\u3042\u3089\u304b\u3058\u3081\u3054\u4e86\u627f\u304f\u3060\u3055\u3044\u3002</p>',
      '<h3>\u8fd4\u54c1\u306b\u3064\u3044\u3066</h3>',
      '<p>\u5546\u54c1\u306b\u4e0d\u5177\u5408\u3084\u7834\u640d\u304c\u3042\u3063\u305f\u5834\u5408\u306f\u3001\u5546\u54c1\u5230\u7740\u5f8c\u3067\u304d\u308b\u3060\u3051\u65e9\u304f\u3054\u9023\u7d61\u304f\u3060\u3055\u3044\u3002\u5185\u5bb9\u3092\u78ba\u8a8d\u306e\u3046\u3048\u3001\u4ea4\u63db\u307e\u305f\u306f\u8fd4\u54c1\u306e\u6d41\u308c\u3092\u3054\u6848\u5185\u3044\u305f\u3057\u307e\u3059\u3002</p>',
      '<h3>\u3054\u78ba\u8a8d\u4e8b\u9805</h3>',
      '<p>\u8a73\u3057\u3044\u6761\u4ef6\u3084\u5bfe\u5fdc\u65b9\u6cd5\u306f\u3001\u30b9\u30c8\u30a2\u306e\u914d\u9001\u30fb\u8fd4\u54c1\u30dd\u30ea\u30b7\u30fc\u3092\u3054\u78ba\u8a8d\u304f\u3060\u3055\u3044\u3002</p>'
    ].join('');

    scope.querySelectorAll(PRODUCT_SECTION_SELECTOR).forEach(function(sectionRoot) {
      setText(sectionRoot.querySelector('.product-block-list__item--description .card__title'), '\u5546\u54c1\u8a73\u7d30');

      toArray(sectionRoot.querySelectorAll('.product-block-list__item--content .card__title')).forEach(function(title, index) {
        if (contentTitles[index]) {
          title.textContent = contentTitles[index];
        }
      });

      setText(sectionRoot.querySelector('.product-block-list__item--reviews .card__title'), '\u30ec\u30d3\u30e5\u30fc');

      toArray(sectionRoot.querySelectorAll('#modal-refunds-policy .rte')).forEach(function(content) {
        if (!content.textContent.trim() || hasMojibake(content.textContent)) {
          content.innerHTML = refundMarkup;
        }
      });
    });
  }

  function collapseBlankReviews(root) {
    var scope = root && root.querySelectorAll ? root : document;

    toArray(scope.querySelectorAll('.product-block-list__item--reviews')).forEach(function(block) {
      var blankFrame = block.querySelector('iframe[src="about:blank"]');
      var anchor = block.querySelector('.product-page__reviews-anchor');
      var wrapper = block.querySelector('.tydal-reviews-iframe-panel-wrapper');
      var card = block.querySelector('.product-reviews-card, .card__section');

      if (!blankFrame) {
        return;
      }

      [blankFrame, anchor, wrapper].forEach(function(node) {
        if (!node) {
          return;
        }

        node.style.setProperty('display', 'none', 'important');
        node.style.setProperty('height', '0px', 'important');
        node.style.setProperty('min-height', '0px', 'important');
        node.style.setProperty('max-height', '0px', 'important');
        node.style.setProperty('margin', '0px', 'important');
        node.style.setProperty('padding', '0px', 'important');
        node.style.setProperty('overflow', 'hidden', 'important');
      });

      if (card) {
        card.style.setProperty('height', 'auto', 'important');
        card.style.setProperty('min-height', '0px', 'important');
      }
    });
  }

  function normalizeRecommendationRails(root) {
    var scope = root && root.querySelectorAll ? root : document;
    var isDesktop = !isMobileViewport();

    toArray(scope.querySelectorAll('[data-section-type="product-recommendations"], .shopify-section--product-recommendations')).forEach(function(section) {
      var list = section.querySelector('.product-list--scrollable, .product-list');
      var viewport = list ? list.querySelector(':scope > .flickity-viewport') : null;
      var slider = viewport ? viewport.querySelector('.flickity-slider') : null;
      var sliderItems = slider ? toArray(slider.querySelectorAll('.product-item')) : [];
      var directItems = list ? toArray(list.querySelectorAll(':scope > .product-item')) : [];
      var items = sliderItems.length ? sliderItems : directItems;
      var cardWidth = isDesktop ? 240 : Math.min(170, Math.round(window.innerWidth * 0.53));

      if (list && slider && sliderItems.length) {
        sliderItems.forEach(function(item) {
          list.appendChild(item);
        });

        viewport.hidden = true;
        viewport.setAttribute('aria-hidden', 'true');
        viewport.style.setProperty('display', 'none', 'important');
        viewport.style.setProperty('height', '0px', 'important');
        viewport.style.setProperty('min-height', '0px', 'important');
        viewport.style.setProperty('max-height', '0px', 'important');
        viewport.style.setProperty('overflow', 'hidden', 'important');
        section.setAttribute('data-tuokus-recommendations-ready', 'true');
        list.setAttribute('data-tuokus-recommendation-rail', 'true');
        items = toArray(list.children).filter(function(child) {
          return child.classList && child.classList.contains('product-item');
        });
      }

      if (!list || !items.length) {
        section.style.setProperty('display', 'none', 'important');
        section.style.setProperty('height', '0px', 'important');
        section.style.setProperty('min-height', '0px', 'important');
        section.style.setProperty('max-height', '0px', 'important');
        section.style.setProperty('margin', '0px', 'important');
        section.style.setProperty('padding', '0px', 'important');
        section.style.setProperty('overflow', 'hidden', 'important');
        return;
      }

      section.setAttribute('data-tuokus-recommendations-ready', 'true');
      section.hidden = false;
      section.removeAttribute('aria-hidden');
      section.style.setProperty('display', 'block', 'important');
      section.style.setProperty('height', 'auto', 'important');
      section.style.setProperty('min-height', '0px', 'important');
      section.style.setProperty('max-height', 'none', 'important');
      section.style.setProperty('margin-top', isDesktop ? '10px' : '8px', 'important');
      section.style.setProperty('margin-bottom', isDesktop ? '18px' : '12px', 'important');
      section.style.setProperty('padding-top', '0px', 'important');
      section.style.setProperty('padding-bottom', '0px', 'important');
      section.style.setProperty('overflow', 'visible', 'important');

      if (section.parentElement && section.parentElement.classList && section.parentElement.classList.contains('shopify-section')) {
        section.parentElement.hidden = false;
        section.parentElement.removeAttribute('aria-hidden');
        section.parentElement.style.setProperty('display', 'block', 'important');
        section.parentElement.style.setProperty('height', 'auto', 'important');
        section.parentElement.style.setProperty('min-height', '0px', 'important');
        section.parentElement.style.setProperty('max-height', 'none', 'important');
        section.parentElement.style.setProperty('overflow', 'visible', 'important');
      }

      list.style.setProperty('display', 'flex', 'important');
      list.style.setProperty('flex-wrap', 'nowrap', 'important');
      list.style.setProperty('align-items', 'stretch', 'important');
      list.style.setProperty('gap', isDesktop ? '14px' : '12px', 'important');
      list.style.setProperty('overflow-x', 'auto', 'important');
      list.style.setProperty('overflow-y', 'hidden', 'important');
      list.style.setProperty('min-height', '0px', 'important');
      list.style.setProperty('height', 'auto', 'important');
      list.style.setProperty('padding-bottom', '8px', 'important');
      list.style.setProperty('scroll-snap-type', 'none', 'important');
      list.style.setProperty('scroll-behavior', 'auto', 'important');
      list.style.setProperty('-webkit-overflow-scrolling', 'touch', 'important');
      list.style.setProperty('touch-action', 'pan-x pan-y pinch-zoom', 'important');

      [viewport, slider].forEach(function(node) {
        if (!node || list.getAttribute('data-tuokus-recommendation-rail') === 'true') {
          return;
        }

        node.style.setProperty('position', 'static', 'important');
        node.style.setProperty('display', 'flex', 'important');
        node.style.setProperty('flex-wrap', 'nowrap', 'important');
        node.style.setProperty('gap', isDesktop ? '14px' : '12px', 'important');
        node.style.setProperty('height', 'auto', 'important');
        node.style.setProperty('min-height', '0px', 'important');
        node.style.setProperty('width', 'max-content', 'important');
        node.style.setProperty('max-width', 'none', 'important');
        node.style.setProperty('overflow', 'visible', 'important');
        node.style.setProperty('transform', 'none', 'important');
      });

      items.forEach(function(item) {
        item.style.setProperty('position', 'static', 'important');
        item.style.setProperty('left', 'auto', 'important');
        item.style.setProperty('transform', 'none', 'important');
        item.style.setProperty('display', 'block', 'important');
        item.style.setProperty('visibility', 'visible', 'important');
        item.style.setProperty('opacity', '1', 'important');
        item.style.setProperty('width', cardWidth + 'px', 'important');
        item.style.setProperty('min-width', cardWidth + 'px', 'important');
        item.style.setProperty('max-width', cardWidth + 'px', 'important');
        item.style.setProperty('flex', '0 0 ' + cardWidth + 'px', 'important');
        forceImages(item);
      });
    });
  }

  function prepareCouponButtons(root) {
    toArray((root || document).querySelectorAll('.product-form__coupon-copy')).forEach(function(button) {
      var couponCode = extractCouponCode(button);

      button.setAttribute('data-tuokus-copy-coupon', 'true');
      button.setAttribute('data-copy-coupon', 'true');
      button.setAttribute('data-coupon-copy-button', 'true');
      if (couponCode) {
        button.setAttribute('data-copy-value', couponCode);
        button.setAttribute('data-coupon-code', couponCode);
      }
      if (!button.getAttribute('data-default-label')) {
        button.setAttribute('data-default-label', button.getAttribute('data-copy-label') || '\u30b3\u30d4\u30fc');
      }
      if (!button.getAttribute('data-copied-label')) {
        button.setAttribute('data-copied-label', '\u30b3\u30d4\u30fc\u6e08\u307f');
      }
      button.setAttribute('type', 'button');
    });

    toArray((root || document).querySelectorAll('.product-coupon-box__button')).forEach(function(button) {
      var couponCode = extractCouponCode(button);

      button.setAttribute('data-tuokus-copy-coupon', 'true');
      button.setAttribute('data-copy-coupon', 'true');
      button.setAttribute('data-coupon-copy-button', 'true');
      if (couponCode) {
        button.setAttribute('data-copy-value', couponCode);
        button.setAttribute('data-coupon-code', couponCode);
      }
      if (!button.getAttribute('data-default-label')) {
        button.setAttribute('data-default-label', button.getAttribute('data-copy-label') || String(button.textContent || '').trim() || '\u30b3\u30d4\u30fc');
      }
      if (!button.getAttribute('data-copied-label')) {
        button.setAttribute('data-copied-label', button.getAttribute('data-copy-success-label') || button.getAttribute('data-copy-success') || '\u30b3\u30d4\u30fc\u6e08\u307f');
      }
      button.setAttribute('type', 'button');
    });
  }

  function getControlForm(control) {
    if (!control) {
      return null;
    }

    return control.form || document.getElementById(control.getAttribute('form') || '');
  }

  function getControlLabel(control, scope) {
    var root = scope && scope.querySelector ? scope : document;

    if (!control || !control.id) {
      return null;
    }

    return root.querySelector('label[for="' + cssEscape(control.id) + '"]') || document.querySelector('label[for="' + cssEscape(control.id) + '"]');
  }

  function getControlDisplayValue(control, scope) {
    var label = getControlLabel(control, scope);
    var option = null;

    if (!control) {
      return '';
    }

    if (control.tagName === 'SELECT') {
      option = control.options[control.selectedIndex];

      return String(
        (option && (option.getAttribute('data-display-value') || option.textContent || option.value)) ||
        control.value ||
        ''
      ).trim();
    }

    return String(
      (label && (label.getAttribute('data-display-value') || label.getAttribute('data-raw-value') || label.textContent)) ||
      control.value ||
      ''
    ).trim();
  }

  function syncSelectedOptionLabel(control) {
    var optionRoot = control && control.closest ? control.closest('.product-form__option') : null;
    var selectedValueNode = optionRoot ? optionRoot.querySelector('.product-form__selected-value') : null;
    var displayValue = getControlDisplayValue(control, optionRoot);

    if (selectedValueNode && displayValue) {
      selectedValueNode.textContent = displayValue;
    }
  }

  function syncOptionVisualState(control) {
    var form = getControlForm(control);
    var scope = form ? document : (control && control.closest ? control.closest(PRODUCT_SECTION_SELECTOR) : document);
    var controls = [];

    if (!control || !control.name) {
      return;
    }

    controls = toArray((scope || document).querySelectorAll('input[name="' + cssEscape(control.name) + '"][data-option-position]'));

    controls.forEach(function(item) {
      var label = getControlLabel(item, document);
      var selected = item === control && item.checked;

      if (label) {
        label.classList.toggle('is-selected', selected);
      }
    });

    syncSelectedOptionLabel(control);
  }

  function getOptionValuesForForm(form) {
    if (!form) {
      return [];
    }

    return toArray(form.elements)
      .filter(function(item) {
        return item.matches && item.matches(
          'input[data-option-position]:checked, ' +
          'input[data-option-position][type="hidden"], ' +
          'select[data-option-position]'
        );
      })
      .sort(function(a, b) {
        return parseInt(a.getAttribute('data-option-position'), 10) - parseInt(b.getAttribute('data-option-position'), 10);
      })
      .map(function(input) {
        return input.value;
      });
  }

  function getRailMemoryKey(control) {
    var form = getControlForm(control);
    var formId = form && form.getAttribute ? form.getAttribute('id') : (control ? control.getAttribute('form') : '');
    var optionPosition = control ? control.getAttribute('data-option-position') : '';

    return formId && optionPosition ? formId + '::' + optionPosition : '';
  }

  function getRailCard(control, rail) {
    var card = null;

    if (!control || !control.closest) {
      return null;
    }

    card = control.closest('.variant-swatch, .block-swatch, .color-swatch');

    if (!card && control.id) {
      card = document.querySelector('label[for="' + cssEscape(control.id) + '"]');
    }

    if (!card || !rail || !card.closest || card.closest(GENERIC_RAIL_SELECTOR) !== rail) {
      return null;
    }

    return card;
  }

  function clampRailScroll(rail, value) {
    var maxScrollLeft = Math.max(rail.scrollWidth - rail.clientWidth, 0);

    return Math.max(0, Math.min(Number(value) || 0, maxScrollLeft));
  }

  function getInteractionScrollLeft(rail) {
    if (!rail) {
      return null;
    }

    if (typeof rail.__tuokusLastPointerScrollLeft === 'number' && Date.now() - (rail.__tuokusLastPointerTime || 0) < 1600) {
      return rail.__tuokusLastPointerScrollLeft;
    }

    return rail.scrollLeft;
  }

  function normalizeRailScrollForControl(control, rail, preferredScrollLeft) {
    var card = null;
    var padding = 8;
    var targetScrollLeft = clampRailScroll(rail, preferredScrollLeft);
    var cardLeft = 0;
    var cardRight = 0;
    var viewportLeft = targetScrollLeft;
    var viewportRight = targetScrollLeft + rail.clientWidth;

    if (!rail) {
      return 0;
    }

    card = getRailCard(control, rail);

    if (!card) {
      return targetScrollLeft;
    }

    cardLeft = card.getBoundingClientRect().left - rail.getBoundingClientRect().left + rail.scrollLeft;
    cardRight = cardLeft + card.getBoundingClientRect().width;

    if (cardLeft - padding < viewportLeft) {
      targetScrollLeft = cardLeft - padding;
    } else if (cardRight + padding > viewportRight) {
      targetScrollLeft = cardRight + padding - rail.clientWidth;
    }

    return clampRailScroll(rail, targetScrollLeft);
  }

  function rememberRailScroll(control, rail, preferredScrollLeft) {
    var key = getRailMemoryKey(control);
    var value = 0;

    if (!key || !rail) {
      return;
    }

    value = clampRailScroll(rail, typeof preferredScrollLeft === 'number' ? preferredScrollLeft : rail.scrollLeft);
    railScrollMemory[key] = value;
    rail.__tuokusLastPointerScrollLeft = value;
    rail.__tuokusLastPointerTime = Date.now();
  }

  function startRailStabilizer(control, rail, targetScrollLeft) {
    var token = 0;

    if (window.__TUOKUS_RAIL_MEMORY_DISABLED || !rail || !control || !control.checked || typeof targetScrollLeft !== 'number') {
      return;
    }

    token = (rail.__tuokusStabilizerToken || 0) + 1;
    rail.__tuokusStabilizerToken = token;

    function tick() {
      var nextScrollLeft = 0;

      if (window.__TUOKUS_RAIL_MEMORY_DISABLED || !control.isConnected || !control.checked || rail.__tuokusStabilizerToken !== token || Date.now() > (rail.__tuokusLockUntil || 0)) {
        return;
      }

      nextScrollLeft = normalizeRailScrollForControl(control, rail, targetScrollLeft);

      if (Math.abs(rail.scrollLeft - nextScrollLeft) > 1) {
        rail.scrollLeft = nextScrollLeft;
      }

      window.requestAnimationFrame(tick);
    }

    tick();
  }

  function restoreRailScroll(control, rail, preferredScrollLeft) {
    var key = getRailMemoryKey(control);
    var remembered = key ? railScrollMemory[key] : null;
    var targetScrollLeft = typeof preferredScrollLeft === 'number' ? preferredScrollLeft : remembered;
    var normalized = 0;
    var restoreToken = 0;

    if (window.__TUOKUS_RAIL_MEMORY_DISABLED || !rail || !control || !control.checked || typeof targetScrollLeft !== 'number') {
      return;
    }

    restoreToken = (rail.__tuokusRestoreToken || 0) + 1;
    rail.__tuokusRestoreToken = restoreToken;
    normalized = normalizeRailScrollForControl(control, rail, targetScrollLeft);
    rail.__tuokusLastPointerScrollLeft = normalized;
    rail.__tuokusLastPointerTime = Date.now();
    rail.__tuokusTargetScrollLeft = normalized;
    rail.__tuokusLockUntil = Date.now() + 1400;
    startRailStabilizer(control, rail, normalized);

    [0, 48, 120, 240, 420, 700, 1040].forEach(function(delay) {
      window.setTimeout(function() {
        if (window.__TUOKUS_RAIL_MEMORY_DISABLED || !control.isConnected || !control.checked || rail.__tuokusRestoreToken !== restoreToken) {
          return;
        }
        var nextScrollLeft = normalizeRailScrollForControl(control, rail, normalized);

        if (Math.abs(rail.scrollLeft - nextScrollLeft) > 1) {
          rail.scrollLeft = nextScrollLeft;
        }

        forceImages(rail);
      }, delay);
    });
  }

  function restoreRememberedRails(sectionRoot) {
    if (window.__TUOKUS_RAIL_MEMORY_DISABLED) {
      return;
    }
    toArray((sectionRoot || document).querySelectorAll('.product-form__single-selector[data-option-position]:checked')).forEach(function(control) {
      var card = control.closest('.variant-swatch, .block-swatch, .color-swatch');
      var rail = card && card.closest ? card.closest(GENERIC_RAIL_SELECTOR) : null;
      var isRecentInteraction = rail && Date.now() - (rail.__tuokusLastPointerTime || 0) < 2200;

      if (isRecentInteraction) {
        restoreRailScroll(control, rail);
      }
    });
  }

  function forceVariantPickerSync(control, previousVariantId) {
    var form = getControlForm(control);
    var formId = form && form.getAttribute ? form.getAttribute('id') : '';
    var picker = null;
    var variantInput = null;
    var optionValues = [];

    if (!control || !form || !formId) {
      return;
    }

    picker = document.querySelector('variant-picker[form-id="' + cssEscape(formId) + '"]');
    variantInput = form.querySelector('input[name="id"]');

    if (!picker || typeof picker.selectCombination !== 'function' || !variantInput) {
      return;
    }

    optionValues = getOptionValuesForForm(form);

    window.setTimeout(function() {
      if (!control.checked || variantInput.value !== previousVariantId) {
        return;
      }

      try {
        picker.selectCombination({
          optionValues: optionValues,
          productChange: control.hasAttribute('data-product-url')
        });
      } catch (error) {
      }
    }, 120);
  }

  function activateOptionControl(control, rail, event, preferredScrollLeft) {
    var form = getControlForm(control);
    var variantInput = form ? form.querySelector('input[name="id"]') : null;
    var previousVariantId = variantInput ? variantInput.value : '';
    var sectionRoot = control && control.closest ? control.closest(PRODUCT_SECTION_SELECTOR) : null;
    var stableScrollLeft = typeof preferredScrollLeft === 'number' ? preferredScrollLeft : getInteractionScrollLeft(rail);

    if (!control || control.disabled || !control.matches || !control.matches('input[data-option-position]')) {
      return false;
    }

    if (event) {
      event.preventDefault();
      event.stopPropagation();

      if (typeof event.stopImmediatePropagation === 'function') {
        event.stopImmediatePropagation();
      }
    }

    rememberRailScroll(control, rail, stableScrollLeft);

    if (!control.checked) {
      control.checked = true;
      syncOptionVisualState(control);
      control.dispatchEvent(new Event('input', { bubbles: true }));
      control.dispatchEvent(new Event('change', { bubbles: true }));
      forceVariantPickerSync(control, previousVariantId);
    } else {
      syncOptionVisualState(control);
    }

    restoreRailScroll(control, rail, stableScrollLeft);

    if (sectionRoot) {
      queueRecovery(sectionRoot);
    }

    return true;
  }

  function setInlineOrder(node, order) {
    if (!node) {
      return;
    }

    if (order === null || typeof order === 'undefined') {
      node.style.removeProperty('order');
      return;
    }

    node.style.order = String(order);
  }

  function setImportantStyle(node, property, value) {
    if (node) {
      node.style.setProperty(property, value, 'important');
    }
  }

  function getSearchUrl() {
    return (window.routes && window.routes.searchUrl) ||
      (window.theme && window.theme.routes && window.theme.routes.searchUrl) ||
      '/search';
  }

  function getVisibleSearchInput(form) {
    var inputs = toArray((form || document).querySelectorAll(SEARCH_INPUT_SELECTOR));

    return inputs.find(function(input) {
      return input.name === 'q' && input.type !== 'hidden' && input.offsetParent !== null;
    }) || inputs.find(function(input) {
      return input.name === 'q' && input.type !== 'hidden';
    }) || null;
  }

  function normalizeSearchForms(root) {
    var scope = root && root.querySelectorAll ? root : document;

    toArray(scope.querySelectorAll(SEARCH_FORM_SELECTOR)).forEach(function(form) {
      var typeInput = form.querySelector('input[name="type"]');

      form.setAttribute('action', getSearchUrl());
      form.setAttribute('method', 'get');
      form.setAttribute('data-tuokus-search-normalized', 'true');

      if (!typeInput) {
        typeInput = document.createElement('input');
        typeInput.type = 'hidden';
        typeInput.name = 'type';
        form.appendChild(typeInput);
      }

      typeInput.value = 'product';
    });
  }

  function submitSearchForm(form, event) {
    var input = form ? getVisibleSearchInput(form) : null;
    var query = input ? String(input.value || '').trim() : '';
    var url = null;

    if (!form || !query) {
      return false;
    }

    if (event) {
      event.preventDefault();
      event.stopPropagation();

      if (typeof event.stopImmediatePropagation === 'function') {
        event.stopImmediatePropagation();
      }
    }

    url = new URL(getSearchUrl(), window.location.origin);
    url.searchParams.set('q', query);
    url.searchParams.set('type', 'product');
    window.location.href = url.toString();
    return true;
  }

  function handleSearchSubmit(event) {
    var form = event.target && event.target.closest ? event.target.closest(SEARCH_FORM_SELECTOR) : null;

    if (form) {
      submitSearchForm(form, event);
    }
  }

  function handleSearchKeydown(event) {
    var input = event.target && event.target.closest ? event.target.closest(SEARCH_INPUT_SELECTOR) : null;
    var form = input ? input.closest(SEARCH_FORM_SELECTOR) : null;

    if (event.key === 'Enter' && form && String(input.value || '').trim()) {
      submitSearchForm(form, event);
    }
  }

  function applyCompactMobileControls(sectionRoot) {
    var lists = [];

    if (!sectionRoot || !isMobileViewport()) {
      return;
    }

    lists = toArray(sectionRoot.querySelectorAll('.variant-swatch-list'));

    lists.forEach(function(list) {
      setImportantStyle(list, 'display', 'flex');
      setImportantStyle(list, 'flex-wrap', 'nowrap');
      setImportantStyle(list, 'justify-content', 'flex-start');
      setImportantStyle(list, 'align-items', 'center');
      setImportantStyle(list, 'gap', '4px');
      setImportantStyle(list, 'column-gap', '4px');
      setImportantStyle(list, 'grid-auto-columns', 'unset');
      setImportantStyle(list, 'overflow-x', 'auto');
      setImportantStyle(list, 'overflow-y', 'hidden');
      setImportantStyle(list, 'padding', '0 0 2px');
      setImportantStyle(list, 'margin', '0');
      setImportantStyle(list, 'scroll-snap-type', 'none');
      setImportantStyle(list, 'scroll-padding-inline', '0');
      setImportantStyle(list, 'scroll-behavior', 'auto');
      setImportantStyle(list, 'overscroll-behavior-x', 'contain');
      setImportantStyle(list, 'touch-action', 'pan-x pan-y pinch-zoom');
      setImportantStyle(list, '-webkit-overflow-scrolling', 'touch');

      if (list.closest('.tuokus-product-layout')) {
        toArray(list.querySelectorAll('.variant-swatch[hidden], .variant-swatch[aria-hidden="true"]')).forEach(function(item) {
          setImportantStyle(item, 'display', 'none');
        });
        return;
      }

      toArray(list.querySelectorAll('.variant-swatch')).forEach(function(item) {
        if (item.hidden || item.getAttribute('aria-hidden') === 'true') {
          setImportantStyle(item, 'display', 'none');
          return;
        }

        setImportantStyle(item, 'box-sizing', 'border-box');
        setImportantStyle(item, 'padding', '0');
        setImportantStyle(item, 'display', 'block');
        setImportantStyle(item, 'flex', '0 0 76px');
        setImportantStyle(item, 'width', '76px');
        setImportantStyle(item, 'min-width', '76px');
        setImportantStyle(item, 'max-width', '76px');
        setImportantStyle(item, 'height', '76px');
        setImportantStyle(item, 'margin', '0');
        setImportantStyle(item, 'scroll-snap-align', 'none');
      });

      toArray(list.querySelectorAll('.variant-swatch__item')).forEach(function(item) {
        setImportantStyle(item, 'display', 'flex');
        setImportantStyle(item, 'align-items', 'center');
        setImportantStyle(item, 'justify-content', 'center');
        setImportantStyle(item, 'box-sizing', 'border-box');
        setImportantStyle(item, 'width', '76px');
        setImportantStyle(item, 'min-width', '76px');
        setImportantStyle(item, 'max-width', '76px');
        setImportantStyle(item, 'height', '76px');
        setImportantStyle(item, 'min-height', '76px');
        setImportantStyle(item, 'max-height', '76px');
        setImportantStyle(item, 'padding', '4px');
        setImportantStyle(item, 'gap', '0');
      });

      toArray(list.querySelectorAll('.variant-swatch__media, .variant-swatch__media.aspect-ratio')).forEach(function(media) {
        setImportantStyle(media, 'width', '68px');
        setImportantStyle(media, 'height', '68px');
        setImportantStyle(media, 'min-width', '68px');
        setImportantStyle(media, 'min-height', '68px');
        setImportantStyle(media, 'padding-bottom', '0');
        setImportantStyle(media, 'border-radius', '13px');
        setImportantStyle(media, 'overflow', 'hidden');
      });

      toArray(list.querySelectorAll('.variant-swatch__image')).forEach(function(image) {
        setImportantStyle(image, 'width', '68px');
        setImportantStyle(image, 'height', '68px');
        setImportantStyle(image, 'object-fit', 'cover');
      });

      toArray(list.querySelectorAll('.variant-swatch__label')).forEach(function(label) {
        setImportantStyle(label, 'display', 'none');
        setImportantStyle(label, 'height', '0');
        setImportantStyle(label, 'min-height', '0');
        setImportantStyle(label, 'margin', '0');
        setImportantStyle(label, 'padding', '0');
        setImportantStyle(label, 'overflow', 'hidden');
      });
    });
  }

  function normalizeMobileThumbnailRail(gallery) {
    var wrapper = null;
    var inner = null;
    var list = null;

    if (!gallery || !isMobileViewport()) {
      return;
    }

    wrapper = gallery.querySelector(':scope > .scroller, .product-gallery__thumbnail-list-wrapper');
    inner = wrapper ? wrapper.querySelector('.scroller__inner') : null;
    list = gallery.querySelector('.product-gallery__thumbnail-list');

    if (wrapper) {
      setImportantStyle(wrapper, 'display', 'block');
      setImportantStyle(wrapper, 'box-sizing', 'border-box');
      setImportantStyle(wrapper, 'width', '100%');
      setImportantStyle(wrapper, 'min-width', '0');
      setImportantStyle(wrapper, 'max-width', '100%');
      setImportantStyle(wrapper, 'height', 'auto');
      setImportantStyle(wrapper, 'min-height', '64px');
      setImportantStyle(wrapper, 'margin', '8px auto 0');
      setImportantStyle(wrapper, 'padding', '0 2px 5px');
      setImportantStyle(wrapper, 'overflow-x', 'auto');
      setImportantStyle(wrapper, 'overflow-y', 'hidden');
      setImportantStyle(wrapper, 'scroll-snap-type', 'none');
      setImportantStyle(wrapper, 'scroll-behavior', 'auto');
      setImportantStyle(wrapper, '-webkit-overflow-scrolling', 'touch');
      setImportantStyle(wrapper, 'touch-action', 'pan-x pan-y pinch-zoom');
      bindMobileGalleryVerticalPan(wrapper);
      wrapper.scrollLeft = Math.max(0, wrapper.scrollLeft);
    }

    if (inner) {
      setImportantStyle(inner, 'display', 'block');
      setImportantStyle(inner, 'position', 'static');
      setImportantStyle(inner, 'box-sizing', 'border-box');
      setImportantStyle(inner, 'width', 'max-content');
      setImportantStyle(inner, 'min-width', '100%');
      setImportantStyle(inner, 'max-width', 'none');
      setImportantStyle(inner, 'transform', 'none');
      setImportantStyle(inner, 'left', '0');
      setImportantStyle(inner, 'right', 'auto');
      setImportantStyle(inner, 'margin-left', '0');
      setImportantStyle(inner, 'margin-right', '0');
      setImportantStyle(inner, 'overflow', 'visible');
    }

    if (list) {
      setImportantStyle(list, 'display', 'flex');
      setImportantStyle(list, 'position', 'static');
      setImportantStyle(list, 'flex-wrap', 'nowrap');
      setImportantStyle(list, 'justify-content', 'flex-start');
      setImportantStyle(list, 'align-items', 'center');
      setImportantStyle(list, 'gap', '7px');
      setImportantStyle(list, 'box-sizing', 'border-box');
      setImportantStyle(list, 'width', 'max-content');
      setImportantStyle(list, 'min-width', '100%');
      setImportantStyle(list, 'max-width', 'none');
      setImportantStyle(list, 'margin', '0');
      setImportantStyle(list, 'padding', '0');
      setImportantStyle(list, 'overflow', 'visible');
      setImportantStyle(list, 'transform', 'none');
      setImportantStyle(list, 'left', '0');
      setImportantStyle(list, 'right', 'auto');
      setImportantStyle(list, 'margin-left', '0');
      setImportantStyle(list, 'margin-right', '0');
      setImportantStyle(list, 'scroll-snap-type', 'none');
    }
  }

  function bindMobileGalleryVerticalPan(wrapper) {
    var gesture = null;
    var options = { capture: true, passive: false };
    var threshold = 8;
    var getTouch = function(event) {
      if (event && event.touches && event.touches.length) {
        return event.touches[0];
      }

      if (event && event.changedTouches && event.changedTouches.length) {
        return event.changedTouches[0];
      }

      return null;
    };
    var reset = function() {
      gesture = null;
    };

    if (!wrapper || wrapper.dataset.tuokusGalleryVerticalPanBound === 'true') {
      return;
    }

    wrapper.dataset.tuokusGalleryVerticalPanBound = 'true';

    wrapper.addEventListener('touchstart', function(event) {
      var point = getTouch(event);

      if (!isMobileViewport() || !point || event.touches.length !== 1) {
        gesture = null;
        return;
      }

      gesture = {
        startX: point.clientX,
        startY: point.clientY,
        lastY: point.clientY,
        mode: ''
      };
    }, options);

    wrapper.addEventListener('touchmove', function(event) {
      var point = getTouch(event);
      var deltaX = 0;
      var deltaY = 0;
      var verticalStep = 0;

      if (!gesture || !isMobileViewport() || !point) {
        return;
      }

      deltaX = point.clientX - gesture.startX;
      deltaY = point.clientY - gesture.startY;

      if (!gesture.mode) {
        if (Math.abs(deltaX) < threshold && Math.abs(deltaY) < threshold) {
          return;
        }

        gesture.mode = Math.abs(deltaY) > Math.abs(deltaX) * 1.15 ? 'vertical' : 'horizontal';
      }

      if (gesture.mode !== 'vertical') {
        return;
      }

      verticalStep = gesture.lastY - point.clientY;
      gesture.lastY = point.clientY;

      if (event.cancelable) {
        event.preventDefault();
      }

      window.scrollBy(0, verticalStep);
    }, options);

    wrapper.addEventListener('touchend', reset, options);
    wrapper.addEventListener('touchcancel', reset, options);
  }

  function copyWithTextarea(value) {
    var textarea = document.createElement('textarea');
    var copied = false;

    textarea.value = String(value || '');
    textarea.setAttribute('readonly', 'readonly');
    textarea.style.position = 'fixed';
    textarea.style.opacity = '0';
    textarea.style.pointerEvents = 'none';
    textarea.style.left = '-9999px';
    textarea.style.top = '0';
    document.body.appendChild(textarea);
    textarea.focus();
    textarea.select();
    textarea.setSelectionRange(0, textarea.value.length);

    try {
      copied = document.execCommand('copy');
    } catch (error) {
      copied = false;
    }

    document.body.removeChild(textarea);
    return copied;
  }

  function copyText(value) {
    var normalized = String(value || '').trim();

    if (!normalized) {
      return Promise.reject(new Error('empty coupon'));
    }

    if (window.isSecureContext && navigator.clipboard && typeof navigator.clipboard.writeText === 'function') {
      return navigator.clipboard.writeText(normalized).catch(function() {
        return copyWithTextarea(normalized) ? Promise.resolve() : Promise.reject(new Error('copy failed'));
      });
    }

    return copyWithTextarea(normalized) ? Promise.resolve() : Promise.reject(new Error('copy failed'));
  }

  function updateCouponButtonState(button, copied) {
    var label = button.querySelector('.product-form__coupon-copy-label, .product-coupon-box__button-label');
    var defaultLabel = button.getAttribute('data-default-label') || button.getAttribute('data-copy-label') || '\u30b3\u30d4\u30fc';
    var copiedLabel = button.getAttribute('data-copied-label') || '\u30b3\u30d4\u30fc\u6e08\u307f';

    button.classList.toggle('is-copied', copied);
    button.setAttribute('data-copy-state', copied ? 'copied' : 'default');
    button.setAttribute('aria-label', copied ? copiedLabel : defaultLabel);

    if (label) {
      label.textContent = copied ? copiedLabel : defaultLabel;
      return;
    }

    button.textContent = copied ? copiedLabel : defaultLabel;
  }

  function extractCouponCode(button) {
    var root = button.closest('[data-coupon-copy-root], .product-form__pricing-panel, .product-coupon-box');
    var codeNode = root ? root.querySelector('[data-coupon-code], .product-form__coupon-code, .product-coupon-box__code') : null;
    var text = String(
      button.getAttribute('data-copy-value') ||
      button.getAttribute('data-coupon-code') ||
      button.getAttribute('data-copy-text') ||
      (codeNode ? (codeNode.getAttribute('data-coupon-code') || codeNode.textContent || '') : '') ||
      (root ? root.textContent || '' : '')
    ).trim();

    return normalizeCouponCode(text || 'WELCOME10');
  }

  function activateCouponCopy(button, event) {
    var couponCode = '';

    if (!button) {
      return;
    }

    couponCode = extractCouponCode(button);

    if (!couponCode) {
      return;
    }

    if (event) {
      event.preventDefault();
      event.stopPropagation();

      if (typeof event.stopImmediatePropagation === 'function') {
        event.stopImmediatePropagation();
      }
    }

    button.setAttribute('data-copy-value', couponCode);
    button.setAttribute('data-coupon-code', couponCode);

    copyText(couponCode).then(function() {
      updateCouponButtonState(button, true);
    }).catch(function() {
      try {
        window.prompt('\u30af\u30fc\u30dd\u30f3\u30b3\u30fc\u30c9\u3092\u30b3\u30d4\u30fc\u3057\u3066\u304f\u3060\u3055\u3044', couponCode);
        updateCouponButtonState(button, true);
      } catch (error) {
        updateCouponButtonState(button, false);
      }
    }).finally(function() {
      window.setTimeout(function() {
        updateCouponButtonState(button, false);
      }, 1800);
    });
  }

  function handleCouponCopy(event) {
    var button = event.target && event.target.closest ? event.target.closest(COPY_BUTTON_SELECTOR) : null;

    if (!button) {
      return;
    }

    activateCouponCopy(button, event);
  }

  function reorderProductFlow(sectionRoot) {
    var wrapper = null;
    var titleBlock = null;
    var galleryBlock = null;
    var infoBlock = null;
    var promotionBlock = null;
    var trailingBlocks = [];

    if (!sectionRoot) {
      return;
    }

    if (!isMobileViewport()) {
      sectionRoot.querySelectorAll('.product-block-list__wrapper > .product-block-list__item').forEach(function(node) {
        setInlineOrder(node, null);
      });

      return;
    }

    wrapper = sectionRoot.querySelector('.product-block-list__wrapper');

    if (!wrapper) {
      return;
    }

    titleBlock = getDirectChild(wrapper, '.product-block-list__item--mobile-title');
    galleryBlock = getDirectChild(wrapper, '.product-block-list__item--gallery');
    infoBlock = getDirectChild(wrapper, '.product-block-list__item--info');
    promotionBlock = getDirectChild(wrapper, '.product-block-list__item--mobile-promotion');
    trailingBlocks = toArray(wrapper.children).filter(function(node) {
      return node !== titleBlock && node !== galleryBlock && node !== infoBlock && node !== promotionBlock;
    });

    setInlineOrder(titleBlock, 1);
    setInlineOrder(galleryBlock, 2);
    setInlineOrder(infoBlock, 3);

    trailingBlocks.forEach(function(node, index) {
      setInlineOrder(node, 4 + index);
    });

    setInlineOrder(promotionBlock, 5);

    [titleBlock, galleryBlock, infoBlock].concat(trailingBlocks).concat([promotionBlock]).forEach(function(node) {
      if (node && node.parentNode === wrapper) {
        wrapper.appendChild(node);
      }
    });
  }

  function reorderVariantSelector(sectionRoot) {
    var block = null;
    var picker = null;
    var infoList = null;
    var pricingPanel = null;

    if (!sectionRoot) {
      return;
    }

    block = sectionRoot.querySelector('.product-info__block-item--variant-selector');

    if (!block) {
      return;
    }

    picker = getDirectChild(block, '.product-form__variants--static, variant-picker');
    infoList = getDirectChild(block, '.product-form__info-list');
    pricingPanel = getDirectChild(block, '.product-form__pricing-panel');

    if (picker) {
      block.appendChild(picker);
    }

    if (infoList) {
      block.appendChild(infoList);
    }

    if (pricingPanel) {
      block.appendChild(pricingPanel);
    }

    if (isMobileViewport()) {
      block.classList.add('tuokus-recovery-variant-block');
      setInlineOrder(picker, 1);
      setInlineOrder(infoList, 2);
      setInlineOrder(pricingPanel, 3);
    } else {
      block.classList.remove('tuokus-recovery-variant-block');
      setInlineOrder(picker, null);
      setInlineOrder(infoList, null);
      setInlineOrder(pricingPanel, null);
    }
  }

  function parseVariantIds(node) {
    return String((node && node.getAttribute && node.getAttribute('data-variant-ids')) || '')
      .split(',')
      .map(function(item) { return item.trim(); })
      .filter(Boolean);
  }

  function isSharedDetailNode(node) {
    var explicit = String((node && node.getAttribute && node.getAttribute('data-tuokus-shared-detail')) || '').toLowerCase();
    var variantIds = parseVariantIds(node);
    var hasGroup = Boolean(node && node.getAttribute && node.getAttribute('data-group-name'));

    if (explicit === 'true' || explicit === '1') {
      return true;
    }

    return variantIds.length === 0 && !hasGroup;
  }

  function showNode(node) {
    if (!node) {
      return;
    }

    node.hidden = false;
    node.classList.remove('is-filtered');
    if (node.classList.contains('product-gallery__carousel-item')) {
      node.classList.remove('product-gallery__carousel-item--hidden');
    }

    if (node.classList.contains('product-gallery__thumbnail')) {
      node.classList.remove('product-gallery__thumbnail--hidden');
    }
    node.removeAttribute('aria-hidden');
    node.style.removeProperty('display');
    node.style.removeProperty('visibility');
    forceImages(node);
  }

  function hideNode(node) {
    if (!node) {
      return;
    }

    node.classList.add('is-filtered');

    if (node.classList.contains('product-gallery__carousel-item')) {
      node.classList.add('product-gallery__carousel-item--hidden');
    }

    if (node.classList.contains('product-gallery__thumbnail')) {
      node.classList.add('product-gallery__thumbnail--hidden');
    }
    node.setAttribute('aria-hidden', 'true');
    node.style.setProperty('display', 'none', 'important');
    node.style.setProperty('visibility', 'hidden', 'important');
  }

  function getSelectedVariantId(sectionRoot) {
    var input = sectionRoot.querySelector('input[name="id"][value]');
    return input ? String(input.value || '').trim() : '';
  }

  function getSelectedOptionValues(sectionRoot) {
    var values = {};

    toArray(sectionRoot.querySelectorAll('.product-form__single-selector')).forEach(function(control) {
      var optionPosition = String(control.getAttribute('data-option-position') || '').trim();
      var selectedOption = null;
      var label = null;
      var normalizedValue = '';

      if (!optionPosition) {
        return;
      }

      if (control.tagName === 'SELECT') {
        selectedOption = control.options[control.selectedIndex];
        normalizedValue = normalizeToken(
          selectedOption ? (
            selectedOption.getAttribute('data-raw-value') ||
            selectedOption.getAttribute('data-display-value') ||
            selectedOption.textContent ||
            selectedOption.value
          ) : control.value
        );
      } else {
        if (!control.checked) {
          return;
        }

        label = control.id ? sectionRoot.querySelector('label[for="' + control.id.replace(/"/g, '\\"') + '"]') : null;
        normalizedValue = normalizeToken(
          label ? (
            label.getAttribute('data-raw-value') ||
            label.getAttribute('data-display-value') ||
            label.textContent
          ) : control.value
        );
      }

      if (normalizedValue) {
        values[optionPosition] = normalizedValue;
      }
    });

    return values;
  }

  function getSelectedOptionsKey(selectedOptions) {
    return Object.keys(selectedOptions || {}).sort().map(function(key) {
      return key + ':' + selectedOptions[key];
    }).join('|');
  }

  function matchesGroupedMedia(node, selectedOptions) {
    var optionPosition = String((node && node.getAttribute && node.getAttribute('data-group-position')) || '').trim();
    var groupedValue = normalizeToken((node && node.getAttribute && node.getAttribute('data-group-value')) || '');

    if (!optionPosition || !groupedValue) {
      return false;
    }

    return selectedOptions[optionPosition] === groupedValue;
  }

  function getVisible(nodes) {
    return nodes.filter(function(node) {
      return !node.classList.contains('is-filtered');
    });
  }

  function getMobileGallerySquareSize(gallery, carousel) {
    var rect = null;
    var size = 0;

    if (!isMobileViewport()) {
      return 0;
    }

    rect = (carousel || gallery).getBoundingClientRect();
    size = Math.round(rect.width || 0);

    if (!size || size < 220) {
      size = Math.max(260, Math.min(window.innerWidth - 32, 360));
    }

    return Math.max(260, Math.min(size, window.innerWidth - 24));
  }

  function applyMobileGallerySquareFrame(gallery, carousel, activeItem) {
    var viewport = carousel ? carousel.querySelector('.flickity-viewport') : null;
    var slider = viewport ? viewport.querySelector('.flickity-slider') : null;
    var limiter = activeItem ? activeItem.querySelector('.product-gallery__size-limiter') : null;
    var ratio = activeItem ? activeItem.querySelector('.aspect-ratio') : null;
    var image = activeItem ? activeItem.querySelector('img') : null;
    var size = getMobileGallerySquareSize(gallery, carousel);

    if (!size || !gallery || !carousel || !activeItem) {
      return 0;
    }

    gallery.style.setProperty('min-height', '0px', 'important');
    gallery.style.setProperty('display', 'block', 'important');
    gallery.style.setProperty('margin-left', 'auto', 'important');
    gallery.style.setProperty('margin-right', 'auto', 'important');
    carousel.style.setProperty('height', size + 'px', 'important');
    carousel.style.setProperty('min-height', size + 'px', 'important');
    carousel.style.setProperty('max-height', size + 'px', 'important');
    carousel.style.setProperty('display', 'block', 'important');
    carousel.style.setProperty('width', '100%', 'important');
    carousel.style.setProperty('max-width', '100%', 'important');
    carousel.style.setProperty('padding', '0px', 'important');
    carousel.style.setProperty('margin-left', 'auto', 'important');
    carousel.style.setProperty('margin-right', 'auto', 'important');

    if (viewport) {
      viewport.style.setProperty('height', size + 'px', 'important');
      viewport.style.setProperty('min-height', size + 'px', 'important');
      viewport.style.setProperty('max-height', size + 'px', 'important');
      viewport.style.setProperty('width', '100%', 'important');
      viewport.style.setProperty('max-width', '100%', 'important');
      viewport.style.setProperty('padding', '0px', 'important');
      viewport.style.setProperty('left', '0px', 'important');
      viewport.style.setProperty('box-sizing', 'border-box', 'important');
    }

    if (slider) {
      slider.style.setProperty('height', size + 'px', 'important');
      slider.style.setProperty('min-height', size + 'px', 'important');
      slider.style.setProperty('max-height', size + 'px', 'important');
    }

    activeItem.style.setProperty('display', 'flex', 'important');
    activeItem.style.setProperty('align-items', 'center', 'important');
    activeItem.style.setProperty('justify-content', 'center', 'important');
    activeItem.style.setProperty('width', '100%', 'important');
    activeItem.style.setProperty('max-width', '100%', 'important');
    activeItem.style.setProperty('height', size + 'px', 'important');
    activeItem.style.setProperty('min-height', size + 'px', 'important');
    activeItem.style.setProperty('max-height', size + 'px', 'important');
    activeItem.style.setProperty('padding', '8px', 'important');
    activeItem.style.setProperty('box-sizing', 'border-box', 'important');
    activeItem.style.setProperty('background', 'transparent', 'important');

    if (limiter) {
      limiter.style.setProperty('width', '100%', 'important');
      limiter.style.setProperty('max-width', '100%', 'important');
      limiter.style.setProperty('height', '100%', 'important');
      limiter.style.setProperty('max-height', '100%', 'important');
      limiter.style.setProperty('min-height', '0px', 'important');
      limiter.style.setProperty('padding', '0px', 'important');
      limiter.style.setProperty('display', 'flex', 'important');
      limiter.style.setProperty('align-items', 'center', 'important');
      limiter.style.setProperty('justify-content', 'center', 'important');
      limiter.style.setProperty('box-sizing', 'border-box', 'important');
      limiter.style.setProperty('overflow', 'hidden', 'important');
    }

    if (ratio) {
      ratio.style.setProperty('width', '100%', 'important');
      ratio.style.setProperty('max-width', '100%', 'important');
      ratio.style.setProperty('height', '100%', 'important');
      ratio.style.setProperty('max-height', '100%', 'important');
      ratio.style.setProperty('min-height', '0px', 'important');
      ratio.style.setProperty('padding-bottom', '0px', 'important');
      ratio.style.setProperty('display', 'flex', 'important');
      ratio.style.setProperty('align-items', 'center', 'important');
      ratio.style.setProperty('justify-content', 'center', 'important');
      ratio.style.setProperty('box-sizing', 'border-box', 'important');
      ratio.style.setProperty('overflow', 'hidden', 'important');
    }

    if (image) {
      image.style.setProperty('position', 'static', 'important');
      image.style.setProperty('display', 'block', 'important');
      image.style.setProperty('width', '100%', 'important');
      image.style.setProperty('height', '100%', 'important');
      image.style.setProperty('max-width', '100%', 'important');
      image.style.setProperty('max-height', '100%', 'important');
      image.style.setProperty('padding', '0px', 'important');
      image.style.setProperty('box-sizing', 'border-box', 'important');
      image.style.setProperty('object-fit', 'contain', 'important');
      image.style.setProperty('object-position', 'center center', 'important');
      image.style.setProperty('margin', 'auto', 'important');
    }

    return size;
  }

  function restoreGalleryHeight(gallery, carousel, activeItem) {
    var height = 0;
    var viewport = carousel ? carousel.querySelector('.flickity-viewport') : null;

    if (!gallery || !carousel || !activeItem || !isMobileViewport()) {
      return;
    }

    height = applyMobileGallerySquareFrame(gallery, carousel, activeItem);

    if (height) {
      return;
    }

    height = Math.ceil(activeItem.scrollHeight || activeItem.getBoundingClientRect().height || 0);

    if (height < 160) {
      return;
    }

    carousel.style.minHeight = height + 'px';
    gallery.style.minHeight = height + 'px';

    if (viewport) {
      viewport.style.height = height + 'px';
      viewport.style.minHeight = height + 'px';
    }
  }

  function forceActiveMediaVisible(activeItem) {
    if (!activeItem) {
      return;
    }

    activeItem.hidden = false;
    activeItem.classList.remove('is-filtered');
    activeItem.classList.remove('product-gallery__carousel-item--hidden');
    activeItem.removeAttribute('aria-hidden');
    activeItem.style.setProperty('display', 'block', 'important');
    activeItem.style.setProperty('visibility', 'visible', 'important');
    activeItem.style.setProperty('opacity', '1', 'important');
    forceImages(activeItem);
  }

  function forceImageLoad(image) {
    var src = '';
    var srcset = '';
    var normalizedSrc = '';

    if (!image || !image.tagName || image.tagName !== 'IMG') {
      return;
    }

    image.setAttribute('loading', 'eager');
    image.setAttribute('decoding', 'async');
    try {
      image.loading = 'eager';
    } catch (error) {}

    src = image.getAttribute('data-src') || image.getAttribute('data-original-src') || image.getAttribute('data-master-src') || image.getAttribute('src') || '';
    srcset = image.getAttribute('data-srcset') || image.getAttribute('data-original-srcset') || image.getAttribute('srcset') || '';
    normalizedSrc = src && src.indexOf('//') === 0 ? window.location.protocol + src : src;

    if (srcset) {
      image.setAttribute('srcset', srcset);
    }

    if (normalizedSrc) {
      if (!image.getAttribute('src') || image.naturalWidth === 0 || !image.currentSrc) {
        image.setAttribute('src', normalizedSrc);
      }
      if (!image.currentSrc || image.naturalWidth === 0) {
        try {
          image.src = normalizedSrc;
        } catch (error) {}
      }
    }
  }

  function forceImages(scope) {
    if (!scope) {
      return;
    }

    if (scope.tagName === 'IMG') {
      forceImageLoad(scope);
      return;
    }

    toArray(scope.querySelectorAll('img')).forEach(forceImageLoad);
  }

  function syncFlickityToActive(carousel, activeItem) {
    if (!carousel || !activeItem || !window.Flickity || typeof window.Flickity.data !== 'function') {
      return;
    }

    try {
      var flickityInstance = window.Flickity.data(carousel);

      if (!flickityInstance) {
        return;
      }

      if (typeof flickityInstance.reloadCells === 'function') {
        flickityInstance.reloadCells();
      }

      if (typeof flickityInstance.selectCell === 'function') {
        flickityInstance.selectCell(activeItem, false, true);
      } else if (typeof flickityInstance.select === 'function') {
        flickityInstance.select(Math.max(0, toArray(carousel.querySelectorAll('.product-gallery__carousel-item:not(.is-filtered)')).indexOf(activeItem)), false, true);
      }

      if (typeof flickityInstance.resize === 'function') {
        flickityInstance.resize();
      }
    } catch (error) {
    }
  }

  function normalizeMobileGalleryLock(gallery, carousel, activeItem) {
    var viewport = null;
    var slider = null;
    var height = 0;

    if (!gallery || !carousel) {
      return;
    }

    if (!isMobileViewport()) {
      gallery.removeAttribute('data-tuokus-gallery-mobile-lock');
      return;
    }

    if (!activeItem) {
      return;
    }

    viewport = carousel.querySelector('.flickity-viewport');
    slider = carousel.querySelector('.flickity-slider');

    gallery.setAttribute('data-tuokus-gallery-mobile-lock', 'true');
    normalizeMobileThumbnailRail(gallery);
    carousel.style.setProperty('width', '100%', 'important');
    carousel.style.setProperty('max-width', '100%', 'important');
    activeItem.style.setProperty('width', '100%', 'important');
    activeItem.style.setProperty('max-width', '100%', 'important');
    activeItem.style.setProperty('left', 'auto', 'important');
    activeItem.style.setProperty('transform', 'none', 'important');

    if (slider) {
      slider.style.setProperty('transform', 'translateX(0px)', 'important');
      slider.style.setProperty('left', '0', 'important');
      slider.style.setProperty('position', 'relative', 'important');
    }

    height = Math.ceil(activeItem.scrollHeight || activeItem.getBoundingClientRect().height || 0);

    if (applyMobileGallerySquareFrame(gallery, carousel, activeItem)) {
      return;
    }

    if (height > 160) {
      carousel.style.setProperty('min-height', height + 'px', 'important');
      if (viewport) {
        viewport.style.setProperty('height', height + 'px', 'important');
        viewport.style.setProperty('min-height', height + 'px', 'important');
      }
    }
  }

  function normalizeGalleryStableLayout(gallery, carousel, activeItem) {
    var viewport = null;
    var slider = null;
    var height = 0;

    if (!gallery || !carousel || !activeItem) {
      return;
    }

    viewport = carousel.querySelector('.flickity-viewport');
    slider = carousel.querySelector('.flickity-slider');

    gallery.setAttribute('data-tuokus-gallery-stable', 'true');
    normalizeMobileThumbnailRail(gallery);
    carousel.style.setProperty('width', '100%', 'important');
    carousel.style.setProperty('max-width', '100%', 'important');
    activeItem.style.setProperty('display', 'block', 'important');
    activeItem.style.setProperty('visibility', 'visible', 'important');
    activeItem.style.setProperty('opacity', '1', 'important');
    activeItem.style.setProperty('left', 'auto', 'important');
    activeItem.style.setProperty('transform', 'none', 'important');

    if (slider) {
      slider.style.setProperty('left', '0', 'important');
      slider.style.setProperty('position', 'relative', 'important');
      slider.style.setProperty('transform', 'translateX(0px)', 'important');
    }

    height = Math.ceil(activeItem.scrollHeight || activeItem.getBoundingClientRect().height || 0);

    if (applyMobileGallerySquareFrame(gallery, carousel, activeItem)) {
      return;
    }

    if (height > 160) {
      carousel.style.setProperty('min-height', height + 'px', 'important');
      if (viewport) {
        viewport.style.setProperty('height', height + 'px', 'important');
        viewport.style.setProperty('min-height', height + 'px', 'important');
      }
    }
  }

  function scrollActiveThumbnail(thumbnail) {
    var rail = null;
    var railRect = null;
    var thumbnailRect = null;
    var padding = 8;

    if (!thumbnail || !thumbnail.closest || typeof thumbnail.getBoundingClientRect !== 'function') {
      return;
    }

    rail = thumbnail.closest('.product-gallery__thumbnail-list') ||
      thumbnail.closest('.product-gallery__thumbnail-list-wrapper') ||
      thumbnail.closest('.scroller');

    if (!rail || typeof rail.getBoundingClientRect !== 'function') {
      return;
    }

    railRect = rail.getBoundingClientRect();
    thumbnailRect = thumbnail.getBoundingClientRect();

    if (rail.scrollWidth > rail.clientWidth + 2) {
      if (thumbnailRect.left < railRect.left + padding) {
        rail.scrollLeft = Math.max(0, rail.scrollLeft + thumbnailRect.left - railRect.left - padding);
      } else if (thumbnailRect.right > railRect.right - padding) {
        rail.scrollLeft = Math.max(0, rail.scrollLeft + thumbnailRect.right - railRect.right + padding);
      }
    }

    if (rail.scrollHeight > rail.clientHeight + 2) {
      if (thumbnailRect.top < railRect.top + padding) {
        rail.scrollTop = Math.max(0, rail.scrollTop + thumbnailRect.top - railRect.top - padding);
      } else if (thumbnailRect.bottom > railRect.bottom - padding) {
        rail.scrollTop = Math.max(0, rail.scrollTop + thumbnailRect.bottom - railRect.bottom + padding);
      }
    }
  }

  function selectGalleryMedia(sectionRoot, mediaId) {
    var gallery = null;
    var carousel = null;
    var activeItem = null;
    var activeThumbnail = null;

    if (!sectionRoot || !mediaId) {
      return false;
    }

    gallery = sectionRoot.querySelector('.product-gallery');
    carousel = sectionRoot.querySelector('.product-gallery__carousel');
    activeItem = sectionRoot.querySelector('.product-gallery__carousel-item[data-media-id="' + mediaId + '"]:not(.is-filtered)') ||
      sectionRoot.querySelector('.product-gallery__carousel-item[data-media-id="' + mediaId + '"]');
    activeThumbnail = sectionRoot.querySelector('.product-gallery__thumbnail[data-media-id="' + mediaId + '"]:not(.is-filtered)') ||
      sectionRoot.querySelector('.product-gallery__thumbnail[data-media-id="' + mediaId + '"]');

    if (!gallery || !carousel || !activeItem) {
      return false;
    }

    showNode(activeItem);
    forceActiveMediaVisible(activeItem);

    toArray(sectionRoot.querySelectorAll('.product-gallery__carousel-item')).forEach(function(item) {
      item.classList.toggle('is-selected', item === activeItem);
      item.removeAttribute('data-tuokus-shared-detail-active');
    });

    if (isSharedDetailNode(activeItem)) {
      activeItem.setAttribute('data-tuokus-shared-detail-active', 'true');
    }

    toArray(sectionRoot.querySelectorAll('.product-gallery__thumbnail')).forEach(function(item) {
      item.classList.toggle('is-nav-selected', item === activeThumbnail);
    });

    if (activeThumbnail) {
      showNode(activeThumbnail);
      scrollActiveThumbnail(activeThumbnail);
    }

    carousel.setAttribute('data-initial-media-id', mediaId);
    restoreGalleryHeight(gallery, carousel, activeItem);
    syncFlickityToActive(carousel, activeItem);
    normalizeGalleryStableLayout(gallery, carousel, activeItem);
    normalizeMobileGalleryLock(gallery, carousel, activeItem);
    normalizeMobileThumbnailRail(gallery);
    restoreGalleryHeight(gallery, carousel, activeItem);

    return true;
  }

  function syncGallery(sectionRoot) {
    var gallery = null;
    var carousel = null;
    var thumbnailWrapper = null;
    var carouselItems = [];
    var thumbnails = [];
    var selectedVariantId = '';
    var selectedOptions = {};
    var selectedOptionsKey = '';
    var lastSelectedOptionsKey = '';
    var lastVariantId = '';
    var variantChanged = false;
    var optionChanged = false;
    var selectedVisibleItem = null;
    var navSelectedThumbnail = null;
    var navSelectedMediaId = '';
    var forcedMediaId = '';
    var forcedItem = null;
    var variantMatchedItem = null;
    var groupedMatchedItem = null;
    var activeItem = null;
    var activeMediaId = '';
    var visibleCount = 0;

    if (!sectionRoot) {
      return;
    }

    gallery = sectionRoot.querySelector('.product-gallery');
    carousel = sectionRoot.querySelector('.product-gallery__carousel');
    thumbnailWrapper = sectionRoot.querySelector('.product-gallery > .scroller, .product-gallery__thumbnail-list-wrapper');
    carouselItems = toArray(sectionRoot.querySelectorAll('.product-gallery__carousel-item'));
    thumbnails = toArray(sectionRoot.querySelectorAll('.product-gallery__thumbnail'));
    selectedVariantId = getSelectedVariantId(sectionRoot);
    selectedOptions = getSelectedOptionValues(sectionRoot);
    selectedOptionsKey = getSelectedOptionsKey(selectedOptions);
    lastVariantId = String(sectionRoot.getAttribute('data-tuokus-last-variant-id') || '');
    lastSelectedOptionsKey = String(sectionRoot.getAttribute('data-tuokus-last-options-key') || '');
    variantChanged = Boolean(selectedVariantId && selectedVariantId !== lastVariantId);
    optionChanged = Boolean(selectedOptionsKey && selectedOptionsKey !== lastSelectedOptionsKey);
    forcedMediaId = String(sectionRoot.getAttribute('data-tuokus-forced-media-id') || '').trim();

    if (!gallery || !carouselItems.length) {
      return;
    }

    carouselItems.forEach(function(item) {
      var variantIds = parseVariantIds(item);
      var matchesVariant = selectedVariantId && variantIds.indexOf(selectedVariantId) > -1;
      var matchesGroup = matchesGroupedMedia(item, selectedOptions);

      if (isSharedDetailNode(item) || matchesVariant || matchesGroup) {
        showNode(item);
        return;
      }

      if (variantIds.length || item.getAttribute('data-group-name')) {
        hideNode(item);
      } else {
        showNode(item);
      }
    });

    thumbnails.forEach(function(item) {
      var variantIds = parseVariantIds(item);
      var matchesVariant = selectedVariantId && variantIds.indexOf(selectedVariantId) > -1;
      var matchesGroup = matchesGroupedMedia(item, selectedOptions);

      if (isSharedDetailNode(item) || matchesVariant || matchesGroup) {
        showNode(item);
        return;
      }

      if (variantIds.length || item.getAttribute('data-group-name')) {
        hideNode(item);
      } else {
        showNode(item);
      }
    });

    selectedVisibleItem = sectionRoot.querySelector('.product-gallery__carousel-item.is-selected:not(.is-filtered)');
    navSelectedThumbnail = sectionRoot.querySelector('.product-gallery__thumbnail.is-nav-selected:not(.is-filtered)');
    navSelectedMediaId = navSelectedThumbnail ? String(navSelectedThumbnail.getAttribute('data-media-id') || '') : '';
    forcedItem = forcedMediaId ? carouselItems.find(function(item) {
      return item.getAttribute('data-media-id') === forcedMediaId && !item.classList.contains('is-filtered');
    }) || null : null;
    variantMatchedItem = carouselItems.find(function(item) {
      return parseVariantIds(item).indexOf(selectedVariantId) > -1;
    }) || null;
    groupedMatchedItem = carouselItems.find(function(item) {
      return !item.classList.contains('is-filtered') && matchesGroupedMedia(item, selectedOptions);
    }) || null;

    if (variantChanged || optionChanged || !selectedVisibleItem) {
      if (!forcedItem) {
        sectionRoot.removeAttribute('data-tuokus-forced-media-id');
      }
      activeItem =
        forcedItem ||
        variantMatchedItem ||
        groupedMatchedItem ||
        selectedVisibleItem ||
        getVisible(carouselItems)[0] ||
        carouselItems[0];
    } else {
      activeItem =
        forcedItem ||
        selectedVisibleItem ||
        (
          navSelectedMediaId
            ? carouselItems.find(function(item) {
                return item.getAttribute('data-media-id') === navSelectedMediaId && !item.classList.contains('is-filtered');
              })
            : null
        ) ||
        variantMatchedItem ||
        groupedMatchedItem ||
        getVisible(carouselItems)[0] ||
        carouselItems[0];
    }

    if (!activeItem) {
      return;
    }

    showNode(activeItem);
    forceActiveMediaVisible(activeItem);
    activeMediaId = String(activeItem.getAttribute('data-media-id') || '');
    sectionRoot.setAttribute('data-tuokus-last-variant-id', selectedVariantId);
    sectionRoot.setAttribute('data-tuokus-last-options-key', selectedOptionsKey);

    carouselItems.forEach(function(item) {
      item.classList.toggle('is-selected', item === activeItem);
      item.removeAttribute('data-tuokus-shared-detail-active');
    });

    if (isSharedDetailNode(activeItem)) {
      activeItem.setAttribute('data-tuokus-shared-detail-active', 'true');
    }

    thumbnails.forEach(function(item) {
      var isActive = activeMediaId && item.getAttribute('data-media-id') === activeMediaId;
      item.classList.toggle('is-nav-selected', isActive);

      if (isActive) {
        showNode(item);
        scrollActiveThumbnail(item);
      }
    });

    visibleCount = Math.max(getVisible(carouselItems).length, getVisible(thumbnails).length);

    if (visibleCount <= 0) {
      showNode(activeItem);
      forceActiveMediaVisible(activeItem);
      visibleCount = 1;
    }

    gallery.setAttribute('data-visible-media-count', String(visibleCount));
    gallery.classList.toggle('product-gallery--single-visible-media', visibleCount <= 1);
    gallery.classList.toggle('product-gallery--few-visible-media', visibleCount > 1 && visibleCount <= 2);

    if (thumbnailWrapper) {
      thumbnailWrapper.classList.toggle('tuokus-shell--empty', visibleCount <= 0);
    }

    if (carousel) {
      carousel.setAttribute('data-initial-media-id', activeMediaId);
      restoreGalleryHeight(gallery, carousel, activeItem);
      syncFlickityToActive(carousel, activeItem);
      normalizeGalleryStableLayout(gallery, carousel, activeItem);
      normalizeMobileGalleryLock(gallery, carousel, activeItem);
      normalizeMobileThumbnailRail(gallery);
      restoreGalleryHeight(gallery, carousel, activeItem);
    }
  }

  function finalizeGalleryVisibility(sectionRoot) {
    var gallery = null;
    var carousel = null;
    var carouselItems = [];
    var thumbnails = [];
    var selectedVariantId = '';
    var selectedOptions = {};
    var forcedMediaId = '';
    var forcedItem = null;
    var activeItem = null;
    var activeMediaId = '';
    var visibleCount = 0;

    if (!sectionRoot) {
      return;
    }

    gallery = sectionRoot.querySelector('.product-gallery');
    carousel = sectionRoot.querySelector('.product-gallery__carousel');
    carouselItems = toArray(sectionRoot.querySelectorAll('.product-gallery__carousel-item'));
    thumbnails = toArray(sectionRoot.querySelectorAll('.product-gallery__thumbnail'));
    selectedVariantId = getSelectedVariantId(sectionRoot);
    selectedOptions = getSelectedOptionValues(sectionRoot);
    forcedMediaId = String(sectionRoot.getAttribute('data-tuokus-forced-media-id') || '').trim();

    if (!gallery || !carouselItems.length) {
      return;
    }

    forcedItem = forcedMediaId ? carouselItems.find(function(item) {
      return item.getAttribute('data-media-id') === forcedMediaId && !item.classList.contains('is-filtered');
    }) || null : null;

    activeItem = forcedItem || carouselItems.find(function(item) {
      return selectedVariantId && parseVariantIds(item).indexOf(selectedVariantId) > -1;
    }) || carouselItems.find(function(item) {
      return matchesGroupedMedia(item, selectedOptions);
    }) || sectionRoot.querySelector('.product-gallery__carousel-item.is-selected:not(.is-filtered)') || getVisible(carouselItems)[0] || carouselItems[0];

    carouselItems.forEach(function(item) {
      var matchesVariant = selectedVariantId && parseVariantIds(item).indexOf(selectedVariantId) > -1;
      var matchesGroup = matchesGroupedMedia(item, selectedOptions);
      var shared = isSharedDetailNode(item);
      var shouldShow = item === activeItem || matchesVariant || matchesGroup || shared;

      item.classList.toggle('is-selected', item === activeItem);

      if (shouldShow) {
        showNode(item);
      } else if (parseVariantIds(item).length || item.getAttribute('data-group-name')) {
        hideNode(item);
      } else {
        showNode(item);
      }
    });

    if (activeItem) {
      forceActiveMediaVisible(activeItem);
      activeMediaId = String(activeItem.getAttribute('data-media-id') || '');
    }

    thumbnails.forEach(function(item) {
      var matchesVariant = selectedVariantId && parseVariantIds(item).indexOf(selectedVariantId) > -1;
      var matchesGroup = matchesGroupedMedia(item, selectedOptions);
      var shared = isSharedDetailNode(item);
      var isActive = activeMediaId && item.getAttribute('data-media-id') === activeMediaId;
      var shouldShow = isActive || matchesVariant || matchesGroup || shared;

      item.classList.toggle('is-nav-selected', isActive);

      if (shouldShow) {
        showNode(item);
        if (isActive) {
          scrollActiveThumbnail(item);
        }
      } else if (parseVariantIds(item).length || item.getAttribute('data-group-name')) {
        hideNode(item);
      }
    });

    visibleCount = Math.max(getVisible(carouselItems).length, getVisible(thumbnails).length);
    gallery.setAttribute('data-visible-media-count', String(Math.max(visibleCount, 1)));
    gallery.classList.toggle('product-gallery--single-visible-media', visibleCount <= 1);
    gallery.classList.toggle('product-gallery--few-visible-media', visibleCount > 1 && visibleCount <= 2);

    if (carousel && activeMediaId) {
      carousel.setAttribute('data-initial-media-id', activeMediaId);
      restoreGalleryHeight(gallery, carousel, activeItem);
      syncFlickityToActive(carousel, activeItem);
      normalizeGalleryStableLayout(gallery, carousel, activeItem);
      normalizeMobileGalleryLock(gallery, carousel, activeItem);
      restoreGalleryHeight(gallery, carousel, activeItem);
    }
  }

  function queueGalleryVisibility(sectionRoot) {
    if (!sectionRoot) {
      return;
    }

    [0, 80, 180, 360, 720, 1200, 1800].forEach(function(delay) {
      window.setTimeout(function() {
        syncGallery(sectionRoot);
        finalizeGalleryVisibility(sectionRoot);
      }, delay);
    });
  }

  function syncPromotionShells(scope) {
    toArray((scope || document).querySelectorAll('.product-gallery__promotion-shell, .product-gallery__promotion-shell--desktop-only, .product-block-list__item--mobile-promotion')).forEach(function(shell) {
      var hasCards = shell.querySelector('.product-item, .tuokus-rail-card, .tuokus-merch-card');
      var desktopOnlyShell = shell.classList.contains('product-gallery__promotion-shell') || shell.classList.contains('product-gallery__promotion-shell--desktop-only') || shell.classList.contains('hidden-pocket');
      var mobileOnlyShell = shell.classList.contains('product-block-list__item--mobile-promotion') || shell.classList.contains('hidden-tablet-and-up');
      var forceHide = !hasCards || (isMobileViewport() && desktopOnlyShell) || (!isMobileViewport() && mobileOnlyShell);

      shell.classList.toggle('tuokus-shell--empty', forceHide);
      shell.hidden = forceHide;
      shell.setAttribute('aria-hidden', forceHide ? 'true' : 'false');

      if (forceHide) {
        shell.style.display = 'none';
      } else {
        shell.style.removeProperty('display');
        forceImages(shell);
      }
    });
  }

  function getControlFromRailTrigger(trigger) {
    var forId = '';
    var control = null;

    if (!trigger) {
      return null;
    }

    if (trigger.control) {
      control = trigger.control;
    }

    if (!control && trigger.getAttribute) {
      forId = trigger.getAttribute('for') || '';

      if (forId) {
        control = document.getElementById(forId);
      }
    }

    if (!control && trigger.querySelector) {
      control = trigger.querySelector('input[data-option-position]');
    }

    if (!control && trigger.closest) {
      var swatch = trigger.closest('.variant-swatch, .block-swatch, .color-swatch');

      if (swatch) {
        control = swatch.querySelector('input[data-option-position]');
      }
    }

    return control && control.matches && control.matches('input[data-option-position]') ? control : null;
  }

  function revealSelectedControl(control) {
    var rail = null;
    var card = null;
    var reveal = null;

    if (!control || !control.closest) {
      return;
    }

    card = control.closest('.variant-swatch, .block-swatch, .color-swatch') ||
      (control.id ? document.querySelector('label[for="' + control.id.replace(/"/g, '\\"') + '"]') : null);
    rail = card && card.closest ? card.closest(GENERIC_RAIL_SELECTOR) : null;

    if (!rail || !card || typeof rail.getBoundingClientRect !== 'function' || typeof card.getBoundingClientRect !== 'function') {
      return;
    }

    reveal = function() {
      var railRect = rail.getBoundingClientRect();
      var cardRect = card.getBoundingClientRect();
      var padding = 10;

      if (cardRect.left < railRect.left + padding) {
        rail.scrollLeft = Math.max(0, rail.scrollLeft + cardRect.left - railRect.left - padding);
      } else if (cardRect.right > railRect.right - padding) {
        rail.scrollLeft = Math.max(0, rail.scrollLeft + cardRect.right - railRect.right + padding);
      }
    };

    window.requestAnimationFrame(function() {
      reveal();
    });
  }

  function bindRail(rail) {
    var state = null;
    var pointerOptions = { capture: true, passive: false };
    var globalListenersBound = false;
    var getPoint = function(event) {
      var touch = null;

      if (event && event.touches && event.touches.length) {
        touch = event.touches[0];
      } else if (event && event.changedTouches && event.changedTouches.length) {
        touch = event.changedTouches[0];
      }

      return touch || event;
    };
    var addGlobalListeners = function(type) {
      if (globalListenersBound) {
        return;
      }

      if (type === 'touch') {
        document.addEventListener('touchmove', moveDrag, pointerOptions);
        document.addEventListener('touchend', finishDrag, pointerOptions);
        document.addEventListener('touchcancel', finishDrag, pointerOptions);
      } else if (type === 'mouse') {
        document.addEventListener('mousemove', moveDrag, pointerOptions);
        document.addEventListener('mouseup', finishDrag, pointerOptions);
      } else {
        document.addEventListener('pointermove', moveDrag, pointerOptions);
        document.addEventListener('pointerup', finishDrag, pointerOptions);
        document.addEventListener('pointercancel', finishDrag, pointerOptions);
      }

      globalListenersBound = true;
    };
    var removeGlobalListeners = function() {
      if (!globalListenersBound) {
        return;
      }

      document.removeEventListener('touchmove', moveDrag, pointerOptions);
      document.removeEventListener('touchend', finishDrag, pointerOptions);
      document.removeEventListener('touchcancel', finishDrag, pointerOptions);
      document.removeEventListener('mousemove', moveDrag, pointerOptions);
      document.removeEventListener('mouseup', finishDrag, pointerOptions);
      document.removeEventListener('pointermove', moveDrag, pointerOptions);
      document.removeEventListener('pointerup', finishDrag, pointerOptions);
      document.removeEventListener('pointercancel', finishDrag, pointerOptions);
      globalListenersBound = false;
    };
    var startDrag = function(event) {
      var point = getPoint(event);
      var trigger = null;
      var control = null;
      var pointerId = event && typeof event.pointerId === 'number' ? event.pointerId : null;

      if (event && event.type === 'mousedown' && event.button !== 0) {
        return;
      }

      if (event && event.type === 'pointerdown' && event.pointerType !== 'touch' && event.button !== 0) {
        return;
      }

      if (!point) {
        return;
      }

      rail.__tuokusLockUntil = 0;
      rail.__tuokusStabilizerToken = (rail.__tuokusStabilizerToken || 0) + 1;
      trigger = event.target && event.target.closest ? event.target.closest('label[for], .variant-swatch__item[for], .block-swatch__item[for], .color-swatch__item[for], .variant-swatch, .block-swatch, .color-swatch') : null;
      control = getControlFromRailTrigger(trigger);

      state = {
        pointerId: pointerId,
        type: event.type.indexOf('touch') === 0 ? 'touch' : event.type.indexOf('mouse') === 0 ? 'mouse' : 'pointer',
        startX: point.clientX,
        startY: point.clientY,
        startScrollLeft: rail.scrollLeft,
        moved: false,
        captured: false,
        control: control
      };

      rail.__tuokusLastPointerScrollLeft = rail.scrollLeft;
      rail.__tuokusLastPointerTime = Date.now();
      addGlobalListeners(state.type);
    };
    var moveDrag = function(event) {
      var point = getPoint(event);
      var deltaX = 0;
      var deltaY = 0;

      if (!state || !point) {
        return;
      }

      if (event && typeof event.pointerId === 'number' && state.pointerId !== null && state.pointerId !== event.pointerId) {
        return;
      }

      deltaX = point.clientX - state.startX;
      deltaY = point.clientY - state.startY;

      if (!state.moved && Math.abs(deltaX) > 6 && Math.abs(deltaX) > Math.abs(deltaY)) {
        state.moved = true;
        rail.style.cursor = 'grabbing';
        rail.classList.add('is-swatch-dragging');
        dragMap.get(rail).suppressClick = true;

        if (event && typeof event.pointerId === 'number' && !state.captured && typeof rail.setPointerCapture === 'function') {
          rail.setPointerCapture(event.pointerId);
          state.captured = true;
        }
      }

      if (!state.moved) {
        return;
      }

      rail.scrollLeft = state.startScrollLeft - deltaX;
      rail.__tuokusLastPointerScrollLeft = rail.scrollLeft;
      rail.__tuokusLastPointerTime = Date.now();

      if (event && event.cancelable) {
        event.preventDefault();
      }
    };
    var finishDrag = function(event) {
      var stableScrollLeft = null;

      if (!state) {
        return;
      }

      if (event && typeof event.pointerId === 'number' && state.pointerId !== null && state.pointerId !== event.pointerId) {
        return;
      }

      stableScrollLeft = state.moved ? rail.scrollLeft : state.startScrollLeft;
      rail.__tuokusLastPointerScrollLeft = stableScrollLeft;
      rail.__tuokusLastPointerTime = Date.now();

      if (event && state.captured && typeof rail.releasePointerCapture === 'function' && state.pointerId !== null && rail.hasPointerCapture(state.pointerId)) {
        rail.releasePointerCapture(state.pointerId);
      }

      rail.style.cursor = 'grab';
      rail.classList.remove('is-swatch-dragging');
      removeGlobalListeners();

      window.setTimeout(function() {
        var railState = dragMap.get(rail);

        if (railState) {
          railState.suppressClick = false;
        }
      }, state.moved ? 180 : 0);

      state = null;
    };

    if (!rail) {
      return;
    }

    forceImages(rail);
    [120, 360, 760, 1400].forEach(function(delay) {
      window.setTimeout(function() {
        forceImages(rail);
      }, delay);
    });

    if (rail.dataset.tuokusRecoveryRailBound === 'true' || rail.dataset.tuokusRecoveryRailBound === 'native') {
      return;
    }

    rail.dataset.tuokusRecoveryRailBound = 'native';
    rail.style.removeProperty('cursor');
    rail.style.setProperty('touch-action', 'pan-x pan-y pinch-zoom', 'important');
    rail.style.setProperty('-webkit-overflow-scrolling', 'touch', 'important');
    rail.style.setProperty('overscroll-behavior-x', 'contain', 'important');
    rail.style.setProperty('scroll-behavior', 'auto', 'important');

    toArray(rail.querySelectorAll('img')).forEach(function(image) {
      image.setAttribute('draggable', 'false');
    });

    // Mobile rails should use native scrolling. The old custom drag layer could
    // capture vertical swipes and make the page feel like it stopped scrolling.
    return;

    dragMap.set(rail, { suppressClick: false });
    rail.addEventListener('scroll', function() {
      var targetScrollLeft = rail.__tuokusTargetScrollLeft;

      if (Date.now() < (rail.__tuokusLockUntil || 0) && typeof targetScrollLeft === 'number' && Math.abs(rail.scrollLeft - targetScrollLeft) > 1) {
        window.requestAnimationFrame(function() {
          if (Date.now() < (rail.__tuokusLockUntil || 0) && Math.abs(rail.scrollLeft - targetScrollLeft) > 1) {
            rail.scrollLeft = targetScrollLeft;
          }
        });
        return;
      }

      rail.__tuokusLastPointerScrollLeft = rail.scrollLeft;
      rail.__tuokusLastPointerTime = Date.now();
    }, { passive: true });

    if (window.PointerEvent) {
      rail.addEventListener('pointerdown', startDrag, pointerOptions);
      rail.addEventListener('pointermove', moveDrag, pointerOptions);
      rail.addEventListener('pointerup', finishDrag, pointerOptions);
      rail.addEventListener('pointercancel', finishDrag, pointerOptions);
      rail.addEventListener('lostpointercapture', finishDrag, true);
    } else {
      rail.addEventListener('mousedown', startDrag, { capture: true, passive: true });
      rail.addEventListener('mousemove', moveDrag, pointerOptions);
      rail.addEventListener('mouseup', finishDrag, pointerOptions);
      rail.addEventListener('mouseleave', finishDrag, pointerOptions);
      rail.addEventListener('touchstart', startDrag, { capture: true, passive: true });
      rail.addEventListener('touchmove', moveDrag, pointerOptions);
      rail.addEventListener('touchend', finishDrag, pointerOptions);
      rail.addEventListener('touchcancel', finishDrag, pointerOptions);
    }

    rail.addEventListener('click', function(event) {
      var railState = dragMap.get(rail);
      var trigger = event.target && event.target.closest ? event.target.closest('label[for], .variant-swatch__item[for], .block-swatch__item[for], .color-swatch__item[for], .variant-swatch, .block-swatch, .color-swatch') : null;
      var control = null;
      var sectionRoot = null;
      var stableScrollLeft = getInteractionScrollLeft(rail);

      if (railState && railState.suppressClick) {
        event.preventDefault();
        event.stopPropagation();
        railState.suppressClick = false;
        return;
      }

      if (!trigger) {
        return;
      }

      control = getControlFromRailTrigger(trigger);

      if (!control || !control.matches || !control.matches('input[data-option-position]') || control.disabled) {
        return;
      }

      sectionRoot = control.closest(PRODUCT_SECTION_SELECTOR);
      activateOptionControl(control, rail, event, stableScrollLeft);

      if (sectionRoot) {
        queueRecovery(sectionRoot);
        queueGalleryVisibility(sectionRoot);
      }
    }, true);
  }

  function bindRails(scope) {
    toArray((scope || document).querySelectorAll(GENERIC_RAIL_SELECTOR)).forEach(bindRail);
  }

  function queueRecovery(sectionRoot) {
    [40, 140, 280, 520, 900, 1400].forEach(function(delay) {
      window.setTimeout(function() {
        runRecovery(sectionRoot);
      }, delay);
    });
  }

  function runRecovery(scope) {
    var root = scope && scope.querySelectorAll ? scope : document;
    var productSections = [];

    injectRuntimeStyles();
    normalizeSearchForms(root);
    normalizeSupportCopy(root);
    collapseBlankReviews(root);
    prepareCouponButtons(root);
    syncPromotionShells(root);
    normalizeRecommendationRails(root);
    bindRails(root);

    if (root.matches && root.matches(PRODUCT_SECTION_SELECTOR)) {
      productSections.push(root);
    }

    productSections = productSections.concat(toArray(root.querySelectorAll(PRODUCT_SECTION_SELECTOR)));

    productSections.forEach(function(sectionRoot) {
      reorderProductFlow(sectionRoot);
      reorderVariantSelector(sectionRoot);
      applyCompactMobileControls(sectionRoot);
      syncGallery(sectionRoot);
      finalizeGalleryVisibility(sectionRoot);
      syncPromotionShells(sectionRoot);
      collapseBlankReviews(sectionRoot);
      normalizeRecommendationRails(sectionRoot);
      restoreRememberedRails(sectionRoot);
    });
  }

  document.addEventListener('click', function(event) {
    var trigger = event.target && event.target.closest ? event.target.closest('label[for], .variant-swatch, .block-swatch, .color-swatch') : null;
    var control = getControlFromRailTrigger(trigger);
    var card = control && control.closest ? control.closest('.variant-swatch, .block-swatch, .color-swatch') : null;
    var rail = card && card.closest ? card.closest(GENERIC_RAIL_SELECTOR) : null;
    var stableScrollLeft = getInteractionScrollLeft(rail);

    if (!control || !rail) {
      return;
    }

    activateOptionControl(control, rail, event, stableScrollLeft);
    queueRecovery(control.closest(PRODUCT_SECTION_SELECTOR));
    queueGalleryVisibility(control.closest(PRODUCT_SECTION_SELECTOR));
  }, true);

  document.addEventListener('click', handleCouponCopy, true);
  document.addEventListener('submit', handleSearchSubmit, true);
  document.addEventListener('keydown', handleSearchKeydown, true);

  document.addEventListener('click', function(event) {
    var button = event.target && event.target.closest ? event.target.closest('.search-bar__submit, button[type="submit"], input[type="submit"]') : null;
    var form = button ? button.closest(SEARCH_FORM_SELECTOR) : null;

    if (form) {
      submitSearchForm(form, event);
    }
  }, true);

  function bindGlobalRailDrag() {
    var active = null;
    var moveOptions = { capture: true, passive: false };
    var startOptions = { capture: true, passive: false };
    var clickWindow = 260;
    var getPoint = function(event) {
      if (event && event.touches && event.touches.length) {
        return event.touches[0];
      }

      if (event && event.changedTouches && event.changedTouches.length) {
        return event.changedTouches[0];
      }

      return event;
    };
    var getRail = function(event) {
      return event && event.target && event.target.closest ? event.target.closest(GENERIC_RAIL_SELECTOR) : null;
    };
    var isSamePointer = function(event) {
      return !active || active.pointerId === null || typeof event.pointerId !== 'number' || event.pointerId === active.pointerId;
    };
    var start = function(event) {
      var rail = getRail(event);
      var point = getPoint(event);

      if (event && event.type === 'mousedown' && event.button !== 0) {
        return;
      }

      if (event && event.type === 'pointerdown' && event.pointerType !== 'touch' && event.button !== 0) {
        return;
      }

      if (!rail || !point || rail.scrollWidth <= rail.clientWidth + 8) {
        return;
      }

      active = {
        rail: rail,
        pointerId: event && typeof event.pointerId === 'number' ? event.pointerId : null,
        startX: point.clientX,
        startY: point.clientY,
        startScrollLeft: rail.scrollLeft,
        moved: false
      };

      rail.__tuokusLastPointerScrollLeft = rail.scrollLeft;
      rail.__tuokusLastPointerTime = Date.now();
    };
    var move = function(event) {
      var point = getPoint(event);
      var deltaX = 0;
      var deltaY = 0;

      if (!active || !point || !isSamePointer(event)) {
        return;
      }

      deltaX = point.clientX - active.startX;
      deltaY = point.clientY - active.startY;

      if (!active.moved) {
        if (Math.abs(deltaY) > 12 && Math.abs(deltaY) > Math.abs(deltaX) * 1.25) {
          active = null;
          return;
        }

        if (Math.abs(deltaX) < 7 || Math.abs(deltaX) < Math.abs(deltaY)) {
          return;
        }

        active.moved = true;
        active.rail.classList.add('is-swatch-dragging');
        active.rail.style.cursor = 'grabbing';
      }

      active.rail.scrollLeft = active.startScrollLeft - deltaX;
      active.rail.__tuokusLastPointerScrollLeft = active.rail.scrollLeft;
      active.rail.__tuokusLastPointerTime = Date.now();

      if (event && event.cancelable) {
        event.preventDefault();
      }

      if (event && event.stopPropagation) {
        event.stopPropagation();
      }
    };
    var end = function(event) {
      var rail = active ? active.rail : null;

      if (!active || !isSamePointer(event)) {
        return;
      }

      if (active.moved && rail) {
        rail.__tuokusGlobalDragClickUntil = Date.now() + clickWindow;
        rail.__tuokusLastPointerScrollLeft = rail.scrollLeft;
        rail.__tuokusLastPointerTime = Date.now();
      }

      if (rail) {
        rail.classList.remove('is-swatch-dragging');
        rail.style.cursor = 'grab';
      }

      active = null;
    };
    var cancelClick = function(event) {
      var rail = getRail(event);

      if (!rail || !rail.__tuokusGlobalDragClickUntil || Date.now() > rail.__tuokusGlobalDragClickUntil) {
        return;
      }

      event.preventDefault();
      event.stopPropagation();
      rail.__tuokusGlobalDragClickUntil = 0;
    };

    if (document.documentElement.dataset.tuokusGlobalRailDragBound === 'true') {
      return;
    }

    document.documentElement.dataset.tuokusGlobalRailDragBound = 'true';
    document.addEventListener('pointerdown', start, startOptions);
    document.addEventListener('pointermove', move, moveOptions);
    document.addEventListener('pointerup', end, moveOptions);
    document.addEventListener('pointercancel', end, moveOptions);
    document.addEventListener('mousedown', start, startOptions);
    document.addEventListener('mousemove', move, moveOptions);
    document.addEventListener('mouseup', end, moveOptions);
    document.addEventListener('touchstart', start, startOptions);
    document.addEventListener('touchmove', move, moveOptions);
    document.addEventListener('touchend', end, moveOptions);
    document.addEventListener('touchcancel', end, moveOptions);
    document.addEventListener('click', cancelClick, true);
  }

  // Per-rail drag binding above owns horizontal drag. The old global layer duplicated pointer streams.
  // bindGlobalRailDrag();

  document.addEventListener('change', function(event) {
    var sectionRoot = event.target && event.target.closest ? event.target.closest(PRODUCT_SECTION_SELECTOR) : null;

    if (!sectionRoot) {
      return;
    }

    sectionRoot.removeAttribute('data-tuokus-forced-media-id');
    queueRecovery(sectionRoot);
    queueGalleryVisibility(sectionRoot);
  }, true);

  document.addEventListener('click', function(event) {
    var sectionRoot = event.target && event.target.closest ? event.target.closest(PRODUCT_SECTION_SELECTOR) : null;
    var thumbnail = event.target && event.target.closest ? event.target.closest('.product-gallery__thumbnail') : null;
    var mediaId = thumbnail ? String(thumbnail.getAttribute('data-media-id') || '').trim() : '';

    if (!sectionRoot) {
      return;
    }

    if (thumbnail && mediaId) {
      event.preventDefault();
      event.stopPropagation();
      if (typeof event.stopImmediatePropagation === 'function') {
        event.stopImmediatePropagation();
      }
      sectionRoot.setAttribute('data-tuokus-forced-media-id', mediaId);
      selectGalleryMedia(sectionRoot, mediaId);
      [0, 80, 220].forEach(function(delay) {
        window.setTimeout(function() {
          if (sectionRoot.getAttribute('data-tuokus-forced-media-id') === mediaId) {
            selectGalleryMedia(sectionRoot, mediaId);
          }
        }, delay);
      });
      queueRecovery(sectionRoot);
      queueGalleryVisibility(sectionRoot);
      return;
    }

    if (event.target.closest('.variant-swatch, .block-swatch, .color-swatch, .product-gallery__thumbnail')) {
      sectionRoot.removeAttribute('data-tuokus-forced-media-id');
      queueRecovery(sectionRoot);
      queueGalleryVisibility(sectionRoot);
    }
  }, true);

  document.addEventListener('variant:change', function(event) {
    var sectionRoot = event.target && event.target.closest ? event.target.closest(PRODUCT_SECTION_SELECTOR) : null;

    if (!sectionRoot && event.detail && event.detail.sectionId) {
      sectionRoot = document.querySelector(PRODUCT_SECTION_SELECTOR + '[data-section-id="' + event.detail.sectionId + '"]');
    }

    if (sectionRoot) {
      sectionRoot.removeAttribute('data-tuokus-forced-media-id');
    }
    queueGalleryVisibility(sectionRoot);
  }, true);

  document.addEventListener('variant:changed', function(event) {
    var sectionRoot = event.target && event.target.closest ? event.target.closest(PRODUCT_SECTION_SELECTOR) : null;

    if (!sectionRoot && event.detail && event.detail.sectionId) {
      sectionRoot = document.querySelector(PRODUCT_SECTION_SELECTOR + '[data-section-id="' + event.detail.sectionId + '"]');
    }

    if (!sectionRoot) {
      return;
    }

    sectionRoot.removeAttribute('data-tuokus-forced-media-id');
    queueRecovery(sectionRoot);
    queueGalleryVisibility(sectionRoot);
  }, true);

  document.addEventListener('product:rerender', function(event) {
    var sectionRoot = event.target && event.target.closest ? event.target.closest(PRODUCT_SECTION_SELECTOR) : null;

    queueGalleryVisibility(sectionRoot);
  }, true);

  document.addEventListener('shopify:section:load', function(event) {
    window.requestAnimationFrame(function() {
      runRecovery(event.target || document);
    });
  });

  document.addEventListener('theme:loading:end', function(event) {
    window.requestAnimationFrame(function() {
      runRecovery(event.target || document);
    });
  });

  window.addEventListener('resize', function() {
    window.requestAnimationFrame(function() {
      runRecovery(document);
    });
  });

  window.addEventListener('pageshow', function() {
    window.requestAnimationFrame(function() {
      runRecovery(document);
    });
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function() {
      runRecovery(document);
    }, { once: true });
  } else {
    runRecovery(document);
  }

  [700, 1600, 3200, 5200].forEach(function(delay) {
    window.setTimeout(function() {
      runRecovery(document);
    }, delay);
  });
})();
